import './create-archive-modal.scss'

import { defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus';
import { EntitySelect, LocalizedString } from '@skinsoft/ui';

export const CreateArchiveModal = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntitySelect: EntitySelect,
        sLocalizedString: LocalizedString,
    },
    props: {
        successRedirectPath: {
            type: String,
            required: true,
        },
    },
    template: require('./create-archive-modal.html'),
    data() {
        return {
            descriptionLevel: null as string | null,
            isSubmitting: false,
        }
    },
    computed: {
        canSubmit(): boolean {
            return !this.isSubmitting && !!this.descriptionLevel
        },
    },
    methods: {
        onDescriptionLevelSelected(selectedValue: any) {
            this.descriptionLevel = selectedValue.id
        },
        onSubmit() {
            this.createNewArchive()
        },
        createNewArchive() {
            if(!this.descriptionLevel) {

                return
            }

            this.isSubmitting = true

            let createArchive$
            if(window.navigator.onLine) {
                createArchive$ = this.$archiveDataStore.createWithDescriptionLevel(this.descriptionLevel)
            } else {
                createArchive$ = this.$archiveDataStore.createWithDescriptionLevelOffline(this.descriptionLevel)
            }

            createArchive$.subscribe(archive => {
                this.isSubmitting = false
                if(archive.id) {
                    this.getToNewArchive(archive.id)
                } else {
                    const alertPayload = {
                        message: this.$t("createArchiveModal.creationFailed"),
                        variant: "danger"
                    }
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                }
            })
        },
        getToNewArchive(id: string) {
            this.$router.push({
                name: this.successRedirectPath,
                params: {archiveId: id},
                query: {imageChoice: 'true'}
            })
        },
        open() {
            (this.$refs.modal as InstanceType<typeof BModal>).show()
        },
    },
})
